import { memo } from "react";

const NOUN_SVG_STYLE = {
  imageRendering: "pixelated",
  transform: "scale(1.5)",
  transformOrigin: "center 55%",
} as const;

export const NounSvg = memo(function NounSvg({ svg }: { svg: string }) {
  return (
    <div
      // biome-ignore lint/security/noDangerouslySetInnerHtml: noun.pics is the trusted source and the bg <rect> is stripped before render.
      dangerouslySetInnerHTML={{ __html: svg }}
      className="h-full w-full [&>svg]:h-full [&>svg]:w-full"
      style={NOUN_SVG_STYLE}
    />
  );
});
